import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import LearningHubCard from './LearningHubCard';
import { fetchAllModules } from '../../requests/learning';
import { getItem } from '../../utils/localStorage';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { useTranslation } from 'react-i18next';
import { publicStaticMediaUrl } from '../../utils/publicStaticMediaUrl';

const Wrapper = styled.div``;

const Cards = styled.div`
  margin-bottom: 87px;
  padding: 25px 20px;
`;

const Content = styled.div`
  margin-top: 70px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 13px;
`;

const Learning = () => {
  const featureFlags = getItem('featureFlags');
  const isLearningGameEnabled =
    featureFlags && featureFlags.isLearningGameEnabled;
  const isBoostersEnabled = featureFlags && featureFlags.isBoostersEnabled;
  const { t } = useTranslation();
  const selectedBrand = parseInt(getItem('selectedBrand'));
  const learningHubItems = [
    {
      key: 1,
      title: t('COMMON.LEARNING.TITLES.LQA_TRAINING_VIDEOS'),
      subtitle: t('COMMON.LEARNING.SUBTITLES.WATCH_ALL_VIDEOS'),
      media: '/assets/img/lqa_training_videos.png',
      navigate: '/learning/training_videos',
    },
    {
      key: 2,
      title: t('COMMON.LEARNING.TITLES.QUIZZES'),
      subtitle: t('COMMON.LEARNING.SUBTITLES.QUIZZES_ASSIGNED_TO_YOU'),
      media: '/assets/img/quizzes.png',
      navigate: '/learning/quizzes',
    },
    {
      key: 3,
      title: t('COMMON.LEARNING.TITLES.LUXURY_STANDARDS'),
      subtitle: t('COMMON.LEARNING.SUBTITLES.REVIEW_ALL_STANDARDS'),
      media: '/assets/img/lqa_standards.png',
      navigate: '/learning/standards?type=LQA',
    },
  ];

  const boostersHubCard = {
    key: 6,
    title: t('COMMON.LEARNING.TITLES.BOOSTERS'),
    subtitle: t('COMMON.LEARNING.SUBTITLES.CHECK_YOUR_BOOSTERS'),
    media: '/assets/img/boosters.png',
    navigate: '/learning/boosters',
  };

  if (isBoostersEnabled) {
    learningHubItems.unshift(boostersHubCard);
  }

  const mandarinHubCard = {
    key: 4,
    title: t('COMMON.LEARNING.TITLES.MANDARIN_ORIENTAL_TRAINING_VIDEOS'),
    subtitle: t('COMMON.LEARNING.SUBTITLES.LEGENDARY_QUALITY_EXPERIENCE'),
    media: publicStaticMediaUrl('training-videos/mandarin-training-videos/preview/Image.png'),
    navigate: '/learning/custom_mandarin',
  };
  const mandarinCardExists = learningHubItems.some(
    (item) => item.key === mandarinHubCard.key
  );
  // tslint:disable-next-line:triple-equals
  if (selectedBrand == 26 && !mandarinCardExists) {
    learningHubItems.push(mandarinHubCard);
  }

  const learningGameHubCard = {
    key: 5,
    title: t('COMMON.LEARNING.TITLES.LEARNIN_GAME'),
    subtitle: t('COMMON.LEARNING.SUBTITLES.LEARNIN_GAME'),
    media: '/assets/img/learning_game.png',
    navigate: '/learning-game',
    analyticsEvent: 'GUEST QUEST: LAUNCHED',
  };

  if (isLearningGameEnabled) {
    learningHubItems.unshift(learningGameHubCard);
  }

  const [learningHubCards, setLearningHubCards] = useState(learningHubItems);
  const [
    emotionalIntelligenceModule,
    setEmotionalIntelligenceModule,
  ] = useState<any>(undefined);
  useEffect(() => {
    (async () => {
      const data = await fetchAllModules();
      const module = data.find(
        (module: { name: string }) => module.name === 'EI Guest Connection'
      );
      if (module) {
        setEmotionalIntelligenceModule(module.modules[0]);
      }
    })();
  }, []);

  useEffect(() => {
    if (emotionalIntelligenceModule) {
      const newLearningHubCards = [
        ...learningHubCards.slice(0, 4),
        {
          key: 5,
          title: t('COMMON.LEARNING.TITLES.LQA_EI_TRAINING'),
          subtitle: t(
            'COMMON.LEARNING.SUBTITLES.ABOUT_EI_BEHAVIORAL_CONNECTION'
          ),
          media: '/assets/img/emotional_intellegence.png',
          navigate: `/learning/eitraining`,
        },
        ...learningHubCards.slice(4),
      ];
      setLearningHubCards(newLearningHubCards);
    }
  }, [emotionalIntelligenceModule]);
  return (
    <Wrapper>
      <div className="header">
        <AppHeader
          title={t('COMMON.LEARNING.TITLES.LQA_LEARNING_HUB')}
          hasBackButton={false}
        />
      </div>
      <Cards>
        <Content>
          {learningHubCards.map((element, idx) => (
            <LearningHubCard key={idx} itemData={element} />
          ))}
        </Content>
      </Cards>
    </Wrapper>
  );
};

export default Learning;
